<div class="d-footer">
	<p class="copyright">© {{ currentYear }} EHE. All rights reserved.</p>
	<p class="terms"><a>Terms and Conditions</a><span>|</span><a>Data Privacy Policy</a></p>
</div>
